export default __webpack_public_path__ + "static/join-b52a37913dac83bf733b1deefafbcee6.jpg";